import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { MatTableModule } from '@angular/material/table';
import { SchedulingComponent } from './scheduling.component';
import {
  DxSchedulerModule,
  DxTemplateModule,
  DxTextBoxModule,
  DxPopupModule,
  DxButtonModule,
  DxBoxModule,
  DxTabPanelModule,
  DxCheckBoxModule,
  DxContextMenuModule,
  DxFormModule,
  DxSelectBoxModule,
  DxDataGridModule,
  DxDropDownBoxModule,
  DxListModule,
  DxValidatorModule, DxDraggableModule, DxPieChartModule
} from 'devextreme-angular';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatTabsModule } from '@angular/material/tabs';
import { MatListModule } from '@angular/material/list';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatBadgeModule } from '@angular/material/badge';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatStepperModule } from '@angular/material/stepper';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TDOPipesModule } from '../tdo-shared/tdo-pipes.module';
import { NoteCompactModule } from '../notes/note-compact/note-compact.module';
import { FormsFormModule } from '../forms/forms-form/forms-form.module';
import {TdoControlsModule} from '../../tdo-controls/tdo-controls.module';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {DirectivesModule} from '../../directives/directives.module';

// import { ValidvalueselectComponent } from '../../tdo-controls/validvalueselect/validvalueselect.component'
// import { TdoSharedModule } from '../tdo-shared/tdo-shared.module';
import { MatSelect } from '@angular/material/select';
import {MainInterfaceModule} from '../../main-interface/main-interface.module';
import {DayDetailViewComponent} from '../../main-interface/scheduler/day-detail-view/day-detail-view.component';
import {PipeModule} from '../../pipes/pipe.module';
//import {FlexModule} from '@angular/flex-layout';
import { AppointmentDialogComponent } from './dialog/appointment-dialog/appointment-dialog.component';
import { AppointmentProcedureDialogComponent } from './dialog/appointment-procedure-dialog/appointment-procedure-dialog.component';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import { WaitListDialogComponent } from './wait-list-dialog/wait-list-dialog.component';
// import {TdoSchedulerComponent} from "../scheduler/tdo-scheduler/tdo-scheduler.component";
// import {EditAppointmentDialogComponent} from "../scheduler/edit-appointment-dialog/edit-appointment-dialog.component";


@NgModule({
    declarations: [
        // ValidvalueselectComponent
        // DxSchedulerComponent,SchedulingComponent
        SchedulingComponent,
        DayDetailViewComponent,
        AppointmentDialogComponent,
        AppointmentProcedureDialogComponent,
        WaitListDialogComponent


    ],
    imports: [
        CommonModule,
        FormsModule,
        PipeModule,
        DirectivesModule,
        NoteCompactModule,
        FormsFormModule,
        DxBoxModule,
        DxFormModule,
        DxSelectBoxModule,
        DxDataGridModule,
        // TdoSharedModule,
        MatTooltipModule,
        MatDialogModule, MatButtonModule, MatCheckboxModule, MatFormFieldModule, MatInputModule,
        MatSelectModule, MatCardModule, MatIconModule, MatExpansionModule, MatDatepickerModule, MatSnackBarModule,
        MatNativeDateModule, MatTabsModule, MatTableModule,
        MatGridListModule, MatListModule, MatRadioModule, MatToolbarModule, MatSidenavModule,
        MatBottomSheetModule, MatButtonToggleModule, MatBadgeModule,
        MatStepperModule, MatBadgeModule, MatProgressSpinnerModule,
        DxSchedulerModule, DxTemplateModule,
        DxPopupModule, DxButtonModule, DxTabPanelModule, DxCheckBoxModule, DxContextMenuModule,
        DxDropDownBoxModule, DxListModule, DxTextBoxModule, TdoControlsModule, DxValidatorModule, MatAutocompleteModule, ReactiveFormsModule, //FlexModule,
        TDOPipesModule, DxDraggableModule, DxPieChartModule, MatProgressBarModule,
    ],
    exports: [
        SchedulingComponent,
        DayDetailViewComponent
    ]
})
export class SchedulingModule { }
